import { defineStore } from 'pinia';
import type { Workspace } from '../types/workspace';
import TeamUser from '../types/teamUser';
import { Step, StepType } from '../types/step';
import { WorkspaceVisibility } from '../types/workspace_visibility';
import { instance } from '../api/instance';
import { CreateEditPopupType } from '@/dashboard/vue/components/popups/CreatePopupTabs/types';

type State = {
  showPopup: boolean;
  isCreate: boolean;
  workspace: Workspace | undefined | null;
  step: StepType;
  tabs: CreateEditPopupType[];
};

export const useWorkspaceAddAndEdit = defineStore('workspaceAddAndEditStore', {
  state: (): State => ({
    showPopup: false,
    isCreate: true,
    workspace: null,
    step: Step.Name,
    tabs: [
      {
        title: 'Workspace',
        step: Step.Name,
      },
      {
        title: 'Members',
        step: Step.Team,
      },
    ],
  }),
  getters: {
    currentUser: (state) => state.workspace?.user,
  },
  actions: {
    async create(name: string, team: TeamUser[], visibility: WorkspaceVisibility): Promise<Workspace> {
      const teamJson = JSON.stringify(team.map((user) => user.json()));
      const formData = new FormData();
      formData.append('name', name);
      formData.append('team', teamJson);
      formData.append('visibility', visibility);

      const response = await instance.post(`/app/workspace/create`, formData);

      const workspace = response.data?.workspace;
      if (workspace) {
        this.closePopup();
      }

      return workspace;
    },
    async edit(name: string, team: TeamUser[], short_link: string, visibility: WorkspaceVisibility): Promise<Workspace | undefined> {
      const teamJson = JSON.stringify(team.map((user) => user.json()));
      const formData = new FormData();
      formData.append('name', name);
      formData.append('short_link', short_link);
      formData.append('team', teamJson);
      formData.append('visibility', visibility);

      const response = await instance.post(`/app/workspace/edit`, formData);

      const workspace = response.data?.workspace;
      if (workspace) {
        this.closePopup();
      }

      return workspace;
    },
    setStep(step: StepType) {
      this.step = step;
    },
    openPopup(isCreate: boolean, workspace?: Workspace, step: StepType = Step.Name) {
      this.showPopup = true;
      this.step = step;
      this.isCreate = isCreate;
      this.workspace = workspace;
    },
    closePopup() {
      this.showPopup = false;
    },
  },
});
